// extracted by mini-css-extract-plugin
module.exports = {"macroInfoboks":"MacroInfoBoks_macroInfoboks__7WM9i"};